import _construct from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/construct.js";
import _toConsumableArray from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _slicedToArray from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/components/Editor/index.tsx
import { Highlight, themes } from "prism-react-renderer";
import { useEffect, useRef, useState } from "react";
import { useEditable } from "use-editable";
import { jsx, jsxs } from "react/jsx-runtime";
var CodeEditor = function CodeEditor(props) {
  var editorRef = useRef(null);
  var _useState = useState(props.code || ""),
    _useState2 = _slicedToArray(_useState, 2),
    code = _useState2[0],
    setCode = _useState2[1];
  var theme = props.theme;
  useEffect(function () {
    setCode(props.code);
  }, [props.code]);
  useEditable(editorRef, function (text) {
    return setCode(text.slice(0, -1));
  }, {
    disabled: props.disabled,
    indentation: props.tabMode === "indentation" ? 2 : void 0
  });
  useEffect(function () {
    if (props.onChange) {
      props.onChange(code);
    }
  }, [code]);
  return /* @__PURE__ */jsx("div", {
    className: props.className,
    style: props.style,
    children: /* @__PURE__ */jsx(Highlight, {
      code: code,
      theme: props.theme || themes.nightOwl,
      language: props.language,
      children: function children(_ref) {
        var _className = _ref.className,
          tokens = _ref.tokens,
          getLineProps = _ref.getLineProps,
          getTokenProps = _ref.getTokenProps,
          _style = _ref.style;
        return /* @__PURE__ */jsx("pre", {
          className: _className,
          style: __spreadValues(__spreadValues({
            margin: 0,
            outline: "none",
            padding: 10,
            fontFamily: "inherit"
          }, theme && typeof theme.plain === "object" ? theme.plain : {}), _style),
          ref: editorRef,
          spellCheck: "false",
          children: tokens.map(function (line, lineIndex) {
            return /* @__PURE__ */jsxs("span", __spreadProps(__spreadValues({}, getLineProps({
              line: line
            })), {
              children: [line.filter(function (token) {
                return !token.empty;
              }).map(function (token, tokenIndex) {
                return /* @__PURE__ */jsx("span", __spreadValues({}, getTokenProps({
                  token: token
                })), "token-".concat(tokenIndex));
              }), "\n"]
            }), "line-".concat(lineIndex));
          })
        });
      }
    })
  });
};
CodeEditor.defaultProps = {
  tabMode: "indentation"
};
var Editor_default = CodeEditor;

// src/components/Live/LiveProvider.tsx
import { useEffect as useEffect2, useState as useState2 } from "react";

// src/components/Live/LiveContext.ts
import { createContext } from "react";
var LiveContext = createContext({});
var LiveContext_default = LiveContext;

// src/utils/transpile/index.ts
import React2 from "react";

// src/utils/transpile/transform.ts
import { transform as _transform } from "sucrase";
var defaultTransforms = ["jsx", "imports"];
function transform() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var transforms = Array.isArray(opts.transforms) ? opts.transforms.filter(Boolean) : defaultTransforms;
  return function (code) {
    return _transform(code, {
      transforms: transforms
    }).code;
  };
}

// src/utils/transpile/errorBoundary.tsx
import React, { Component } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var errorBoundary = function errorBoundary(Element, errorCallback) {
  return /*#__PURE__*/function (_Component) {
    _inherits(ErrorBoundary, _Component);
    var _super = _createSuper(ErrorBoundary);
    function ErrorBoundary() {
      _classCallCheck(this, ErrorBoundary);
      return _super.apply(this, arguments);
    }
    _createClass(ErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error) {
        errorCallback(error);
      }
    }, {
      key: "render",
      value: function render() {
        return typeof Element === "function" ? /* @__PURE__ */jsx2(Element, {}) : React.isValidElement(Element) ? Element : null;
      }
    }]);
    return ErrorBoundary;
  }(Component);
};
var errorBoundary_default = errorBoundary;

// src/utils/transpile/evalCode.ts
var evalCode = function evalCode(code, scope) {
  var scopeKeys = Object.keys(scope);
  var scopeValues = scopeKeys.map(function (key) {
    return scope[key];
  });
  return _construct(Function, scopeKeys.concat([code])).apply(void 0, _toConsumableArray(scopeValues));
};
var evalCode_default = evalCode;

// src/utils/transpile/compose.ts
function compose() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }
  return functions.reduce(function (acc, currentFn) {
    return function () {
      return acc(currentFn.apply(void 0, arguments));
    };
  });
}

// src/utils/transpile/index.ts
var jsxConst = 'const _jsxFileName = "";';
var trimCode = function trimCode(code) {
  return code.trim().replace(/;$/, "");
};
var spliceJsxConst = function spliceJsxConst(code) {
  return code.replace(jsxConst, "").trim();
};
var addJsxConst = function addJsxConst(code) {
  return jsxConst + code;
};
var wrapReturn = function wrapReturn(code) {
  return "return (".concat(code, ")");
};
var generateElement = function generateElement(_ref2, errorCallback) {
  var _ref2$code = _ref2.code,
    code = _ref2$code === void 0 ? "" : _ref2$code,
    _ref2$scope = _ref2.scope,
    scope = _ref2$scope === void 0 ? {} : _ref2$scope,
    _ref2$enableTypeScrip = _ref2.enableTypeScript,
    enableTypeScript = _ref2$enableTypeScrip === void 0 ? true : _ref2$enableTypeScrip;
  var firstPassTransforms = ["jsx"];
  enableTypeScript && firstPassTransforms.push("typescript");
  var transformed = compose(addJsxConst, transform({
    transforms: ["imports"]
  }), wrapReturn, spliceJsxConst, trimCode, transform({
    transforms: firstPassTransforms
  }), trimCode)(code);
  return errorBoundary_default(evalCode_default(transformed, __spreadValues({
    React: React2
  }, scope)), errorCallback);
};
var renderElementAsync = function renderElementAsync(_ref3, resultCallback, errorCallback) {
  var _ref3$code = _ref3.code,
    code = _ref3$code === void 0 ? "" : _ref3$code,
    _ref3$scope = _ref3.scope,
    scope = _ref3$scope === void 0 ? {} : _ref3$scope,
    _ref3$enableTypeScrip = _ref3.enableTypeScript,
    enableTypeScript = _ref3$enableTypeScrip === void 0 ? true : _ref3$enableTypeScrip;
  var render = function render(element) {
    if (typeof element === "undefined") {
      errorCallback(new SyntaxError("`render` must be called with valid JSX."));
    } else {
      resultCallback(errorBoundary_default(element, errorCallback));
    }
  };
  if (!/render\s*\(/.test(code)) {
    return errorCallback(new SyntaxError("No-Inline evaluations must call `render`."));
  }
  var transforms = ["jsx", "imports"];
  enableTypeScript && transforms.splice(1, 0, "typescript");
  evalCode_default(transform({
    transforms: transforms
  })(code), __spreadProps(__spreadValues({
    React: React2
  }, scope), {
    render: render
  }));
};

// src/components/Live/LiveProvider.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
function LiveProvider(_ref4) {
  var children = _ref4.children,
    _ref4$code = _ref4.code,
    code = _ref4$code === void 0 ? "" : _ref4$code,
    _ref4$language = _ref4.language,
    language = _ref4$language === void 0 ? "tsx" : _ref4$language,
    theme = _ref4.theme,
    _ref4$enableTypeScrip = _ref4.enableTypeScript,
    enableTypeScript = _ref4$enableTypeScrip === void 0 ? true : _ref4$enableTypeScrip,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
    scope = _ref4.scope,
    transformCode = _ref4.transformCode,
    _ref4$noInline = _ref4.noInline,
    noInline = _ref4$noInline === void 0 ? false : _ref4$noInline;
  var _useState3 = useState2({
      error: void 0,
      element: void 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  function transpileAsync(newCode) {
    return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var errorCallback, transformResult, transformedCode, renderElement, input;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            errorCallback = function errorCallback(error) {
              setState({
                error: error.toString(),
                element: void 0
              });
            };
            _context.prev = 1;
            transformResult = transformCode ? transformCode(newCode) : newCode;
            _context.prev = 3;
            _context.next = 6;
            return Promise.resolve(transformResult);
          case 6:
            transformedCode = _context.sent;
            renderElement = function renderElement(element) {
              return setState({
                error: void 0,
                element: element
              });
            };
            if (!(typeof transformedCode !== "string")) {
              _context.next = 10;
              break;
            }
            throw new Error("Code failed to transform");
          case 10:
            input = {
              code: transformedCode,
              scope: scope,
              enableTypeScript: enableTypeScript
            };
            if (noInline) {
              setState({
                error: void 0,
                element: null
              });
              renderElementAsync(input, renderElement, errorCallback);
            } else {
              renderElement(generateElement(input, errorCallback));
            }
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", errorCallback(_context.t0));
          case 17:
            _context.next = 23;
            break;
          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](1);
            errorCallback(_context.t1);
            return _context.abrupt("return", Promise.resolve());
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 19], [3, 14]]);
    }));
  }
  var onError = function onError(error) {
    return setState({
      error: error.toString()
    });
  };
  useEffect2(function () {
    transpileAsync(code).catch(onError);
  }, [code, scope, noInline, transformCode]);
  var onChange = function onChange(newCode) {
    transpileAsync(newCode).catch(onError);
  };
  return /* @__PURE__ */jsx3(LiveContext_default.Provider, {
    value: __spreadProps(__spreadValues({}, state), {
      code: code,
      language: language,
      theme: theme,
      disabled: disabled,
      onError: onError,
      onChange: onChange
    }),
    children: children
  });
}
var LiveProvider_default = LiveProvider;

// src/components/Live/LiveEditor.tsx
import { useContext } from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
function LiveEditor(props) {
  var _useContext = useContext(LiveContext_default),
    code = _useContext.code,
    language = _useContext.language,
    theme = _useContext.theme,
    disabled = _useContext.disabled,
    onChange = _useContext.onChange;
  return /* @__PURE__ */jsx4(Editor_default, __spreadValues({
    theme: theme,
    code: code,
    language: language,
    disabled: disabled,
    onChange: onChange
  }, props));
}

// src/components/Live/LiveError.tsx
import { useContext as useContext2 } from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
function LiveError(props) {
  var _useContext2 = useContext2(LiveContext_default),
    error = _useContext2.error;
  return error ? /* @__PURE__ */jsx5("pre", __spreadProps(__spreadValues({}, props), {
    children: error
  })) : null;
}

// src/components/Live/LivePreview.tsx
import { useContext as useContext3 } from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
function LivePreview(_a) {
  var _b = _a,
    _b$Component = _b.Component,
    Component2 = _b$Component === void 0 ? "div" : _b$Component,
    rest = __objRest(_b, ["Component"]);
  var _useContext3 = useContext3(LiveContext_default),
    Element = _useContext3.element;
  return /* @__PURE__ */jsx6(Component2, __spreadProps(__spreadValues({}, rest), {
    children: Element ? /* @__PURE__ */jsx6(Element, {}) : null
  }));
}
var LivePreview_default = LivePreview;

// src/hoc/withLive.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
function withLive(WrappedComponent) {
  var WithLive = function WithLive(props) {
    return /* @__PURE__ */jsx7(LiveContext_default.Consumer, {
      children: function children(live) {
        return /* @__PURE__ */jsx7(WrappedComponent, __spreadValues({
          live: live
        }, props));
      }
    });
  };
  WithLive.displayName = "WithLive";
  return WithLive;
}
export { Editor_default as Editor, LiveContext_default as LiveContext, LiveEditor, LiveError, LivePreview_default as LivePreview, LiveProvider_default as LiveProvider, generateElement, renderElementAsync, withLive };